import { render } from "./PlanTransportGroupResultLoadingSchemeJournal.vue?vue&type=template&id=16220e46&ts=true"
import script from "./PlanTransportGroupResultLoadingSchemeJournal.vue?vue&type=script&lang=ts"
export * from "./PlanTransportGroupResultLoadingSchemeJournal.vue?vue&type=script&lang=ts"

import "./PlanTransportGroupResultLoadingSchemeJournal.vue?vue&type=style&index=0&id=16220e46&lang=css"

import exportComponent from "C:\\BuildAgent\\work\\2f08168a1cda37d3\\Loading\\loading_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__